
$(document).ready(function () {
  var winWidthSm = 992;
  var speed = 600;
  var formId = $('#js-mailform');
  var headerId = $('#js-header');

  formId.prepend('<input type="hidden" name="javascript_action" value="true">');

  $('.c-form').each(function () {
    $(this).children('.c-form__confirm').css('display', 'none');
  });

  $.extend($.validator.messages, {
    required: '必須項目です。',
    email: 'メールアドレスの形式が正しくありません。',
    postal: '郵便番号の形式が正しくありません。',
    alphanum: '半角英数字で入力してください。',
    alpha: '半角英字で入力してください。',
    phone: '半角数字と「-」のみ使用できます。',
    equalTo: '同じ値を入力してください。',
    number: '半角数字で入力してください。',
    digits: '半角数字で入力してください。',
    url: 'URLの形式が正しくありません。',
    date: '日付の形式が正しくありません。',
    minlength: $.validator.format("最低 {0} 文字以上で入力してください。"),
    maxlength: $.validator.format("最大 {0} 文字以下で入力してください。"),
    min: $.validator.format("{0} より大きな数にしてください。"),
    max: $.validator.format("{0} より小さな数にしてください。"),
    step: '{0} の倍数を入力してください。',
    kana: '全角ひらがな、カタカナで入力してください。',
    hiragana: '全角ひらがなで入力してください。',
    katakana: '全角カタカナで入力してください。',
  });

  var methods = {
    postal: function (value, element) {
      return this.optional(element) || /^[0-9]{3}-?[0-9]{4}$/.test(value);
    },
    alphanum: function (value, element) {
      return this.optional(element) || /^[a-zA-Z0-9_]+$/.test(value);
    },
    alpha: function (value, element) {
      return this.optional(element) || /^[a-zA-Z]+$/.test(value);
    },
    phone: function (value, element) {
      return this.optional(element) || /^[0-9\-\ ]+$/.test(value);
    },
    kana: function (value, element) {
      return this.optional(element) || /^[ぁ-んァ-ヶー　\ ]+$/.test(value);
    },
    hiragana: function (value, element) {
      return this.optional(element) || /^[ぁ-んー　\ ]+$/.test(value);
    },
    katakana: function (value, element) {
      return this.optional(element) || /^[ァ-ヶー　\ ]+$/.test(value);
    },
  };
  $.each(methods, function (key) {
    $.validator.addMethod(key, this);
  });

  formId.validate({
    rules: {
      '会社名': {
        required: true
      },
      'ご担当者名': {
        required: true
      },
      'メールアドレス': {
        required: true,
        email: true
      },
      '電話番号': {
        phone: true,
        minlength: 10,
        maxlength: 14
      },
      '郵便番号': {
        postal: true,
      },
      '業種': {
        required: true
      },
      '業種': {
        required: true
      },
      'ECサイトURL': {
        url: true,
      },
      'お問い合わせ内容': {
        required: true,
      },
      '個人情報の利用目的': {
        required: true
      },
    },
    errorPlacement: function (error, element) {
      name = element.attr("name");
      if (
        name == '個人情報の利用目的' ||
        name == '郵便番号'
      ) {
        var str = name.replace(/\[\d*\]/g, '');
        error.prependTo($("#" + str + "_error"));
      } else {
        error.insertAfter(element);
      }
    }
  });


  $('#js-formConfirm').on('click', function () {

    formCheck = formId.valid();

    if (formCheck) {
      $('.c-form').each(function () {

        var iInput = $(this).children('.c-form__input');
        var iConfirm = $(this).children('.c-form__confirm');
        if (iInput.length) {
          if (iInput.hasClass('-cb')) {
            var chText = '';
            iInput.find('.c-form__inputTag').each(function (index, element) {
              if ($(this).prop('checked') == true) {
                if (chText != '') { chText = chText + '、'; }
                chText = chText + sanitizing($(this).val());
                iConfirm.html(chText);
              }
            });
          } else {
            var iInputTag = iInput.find('.c-form__inputTag');
            if (iInputTag.length) {
              var iVal = iInputTag.val();
              if (typeof iVal !== 'undifined') {
                iConfirm.html(sanitizing(iVal));
              }
            }
          }
        }

        iInput.css('display', 'none');
        iConfirm.css('display', 'block');
      });
    }

    var winWidth = $(window).width();
    if (winWidth >= winWidthSm) {
      var headHeight = 0;
    } else {
      var headHeight = headerId.outerHeight();
    }
    var position = formId.offset().top - headHeight;

    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });


  $('#js-formBack').on('click', function () {
    $('.c-form').each(function () {
      var iInput = $(this).children('.c-form__input');
      var iConfirm = $(this).children('.c-form__confirm');
      iInput.css('display', 'block');
      iConfirm.css('display', 'none');
    });

    var winWidth = $(window).width();
    if (winWidth >= winWidthSm) {
      var headHeight = 0;
    } else {
      var headHeight = headerId.outerHeight();
    }
    var position = formId.offset().top - headHeight;

    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

});



// サニタイズ関数
function sanitizing(str) {
  var before = new Array('&', '"', "'", "<", ">", "\n", "\t", "\\n");
  var after = new Array('&amp;', '&quot;', '&rsquo;', "&lt;", "&gt;", "<br />", " ", "<br />");
  for (var i = 0; i < before.length; i++)
    str = str.replace(new RegExp(before[i], 'g'), after[i]);
  return str;
};